import React from 'react'
import parse from 'html-react-parser';
import { Row, Col } from 'react-bootstrap';
import { Modal, Form, OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import Select from 'react-select';
import { connect } from "react-redux";
import plus from "../../../assets/images/ar-g.svg";
import { clearConfirmDropdownList, createBoq, role, setTitle } from '../../../actions';
import { getSentBoqProductList } from '../../../actions/billofquantityActions';
import { toast } from 'react-toastify';


class UnConvertBoq extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            openedItem: [],
            quotationId: "",
            referenceId: "",
            dropDownList: [],
            projects: [],
            confirmPopup: false,
        }
        this.productHandler = this.productHandler.bind(this);
        this.selectHandler = this.selectHandler.bind(this);
        this.selectProHandler = this.selectProHandler.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.clickHandler = this.clickHandler.bind(this);
        this.confirmPopupClose = this.confirmPopupClose.bind(this);
        this.confirmPopupOpen = this.confirmPopupOpen.bind(this);
    }
    selectHandler(e) {
        const { openedItem } = this.state;
        let newItems = openedItem.map((i) => i = e.target.checked);
        this.setState({
            openedItem: newItems,
        })
    }
    selectProHandler(e, index) {
        console.log(e, index, "e, index");
        const { openedItem } = this.state;
        let newItems = openedItem.map((item, i) => index === i ? e.target.checked : item);
        this.setState({
            openedItem: newItems
        })
    }
    confirmPopupOpen() {
        const { openedItem } = this.state;
        if (openedItem.includes(true)) {
            this.setState({
                confirmPopup: true
            })
        } else {
            toast("Select Atleast One Product");
        }
    }
    confirmPopupClose() {
        this.setState({
            confirmPopup: false
        })
    }
    changeHandler = (e, index) => {
        const { data } = this.state;
        let a = Number(data[index].quantity);
        let b = e.target.value;
        if (b && !/^([0-9]{1,5})+(\.[0-9]{0,2})?$/i.test(b)) {
            toast("Enter valid digits Ex(19.00,23456.45,200.34)");
            return false;
        }
        data[index]["boqQuantity"] = b;
        if (+b <= a) {
            this.setState({
                data: data
            })
        }
        else {
            toast("Pls enter the number less than or equal to " + a);
        }
    }
    productHandler(e) {
        this.state.dropDownList?.map((item) => {
            if (item?.quotationId == e.value) {
                let data = [];
                this.setState({
                    data: item?.quotationGroupProductResDto,
                    quotationId: item?.quotationId,
                    referenceId: item?.referenceId
                })
                item?.quotationGroupProductResDto?.map((item, i) => data[i] = false);
                this.setState({
                    openedItem: data
                })
            }
        });
    }
    clickHandler() {
        this.setState({
            data: [],
        })
        this.props.handleShow();
    }
    submitHandler() {
        const { openedItem, data, quotationId } = this.state;
        let pro = [];
        data?.map((item, i) => {
            let items = {};
            if (openedItem[i]) {
                if (Number(item.boqQuantity) !== 0) {
                    items["productId"] = item.productId;
                    // items["productGroupId"] = item.productGroupId;
                    items["boqQuantity"] = Number(item.boqQuantity);
                    pro.push(items);
                }
            }
        });
        let formData = {
            "quotationId": quotationId,
            "productReqDtoList": pro
        }
        this.props.dispatch(createBoq(formData));
    }
    componentDidMount() {
        // Removed API call from here
    }
    componentDidUpdate(prevProps) {
        // Call API when popup opens and quotData is available
        if (
            this.props.show && // popup is open
            !prevProps.show && // it was previously closed
            this.props.quotData &&
            this.props.quotData.billOfQuantityId
        ) {
            this.props.dispatch(getSentBoqProductList(this.props.quotData.billOfQuantityId));
        }
        console.log(this.props.sentBoqProductList, "this.props.sentBoqProductList?.data");
        if (
            this.props.sentBoqProductList !== prevProps.sentBoqProductList &&
            Array.isArray(this.props.sentBoqProductList?.boqProductList)
        ) {
            let data = [];
            this.props.sentBoqProductList?.boqProductList?.map((item, i) => data[i] = false);
            this.setState({
                openedItem: data,
                data: this.props.sentBoqProductList?.boqProductList,
                quotationId: this.props.sentBoqProductList?.quotationId
            });
        }  
    }

    render() {
        const { show, onHide, quotData, loading, load, sentBoqProductList } = this.props;
        const { data, openedItem, dropDownList, confirmPopup, referenceId, projects } = this.state;
        return (
            <div>
                <>
                    <Modal
                        show={show}
                        size="xl"
                        onHide={() => {
                            onHide();
                            this.setState({
                                data: []
                            })
                        }}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <div className="modal-staff">
                            <div className="head">
                                <div>
                                    <i class="fas fa-arrow-left" onClick={() => {
                                        onHide();
                                    }}></i>
                                    <p >CONVERT <span><h4>{`${quotData?.billOfQuantityNumber}`} </h4></span> TO BOQ</p>
                                </div>
                            </div>
                            <div className="table-class space-part">
                                <table class="table table-borderless">
                                    <thead >
                                        <tr>
                                            <th scope="col">
                                                Art ID
                                            </th>
                                            <th scope="col">
                                                Product Name
                                            </th>
                                            <th scope="col">
                                                Qty
                                            </th>
                                            <th scope="col">
                                                BOQ Qty
                                            </th>
                                            <th scope="col" className='check-item'>
                                                Select
                                                <input type="checkbox" onChange={this.selectHandler} style={{ margin: "7px" }} />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <div className="empty-data">
                                                <Spinner />
                                            </div>
                                        ) : data === null || data === undefined || data?.length === 0 ? (
                                            <div>
                                                <h1 className="empty-data">No Records Found</h1> :
                                            </div>
                                        ) : data?.map((item, i) => (
                                            <tr key={i} >
                                                <td>{item?.articleId}</td>
                                                <td>
                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {parse(item.productName || "-")}</Tooltip>}>
                                                        <span className="d-inline-block new-line">
                                                            {parse(item.productName || "-")}
                                                        </span>
                                                    </OverlayTrigger>
                                                </td>
                                                <td>{item?.quantity}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        maxLength="8"
                                                        className='convert_po_input'
                                                        value={item?.boqQuantity}
                                                        onChange={(e) => this.changeHandler(e, i)} />
                                                </td>
                                                <td >
                                                    <Form.Check
                                                        checked={openedItem[i] ? true : false}
                                                        onChange={(e) => this.selectProHandler(e, i)}
                                                        name="group1"
                                                        type="checkbox"
                                                        className="form-check-box"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <center style={{ padding: "10px" }}>
                                <button className="customer-btn col-md-5" onClick={() => this.confirmPopupOpen()}>Convert to BOQ</button>
                            </center>
                        </div>
                    </Modal>
                </>
                <Modal
                    show={confirmPopup}
                    onHide={() => {
                        this.setState({
                            confirmPopup: false
                        });
                    }}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <div className="modal-success">
                        <h5>Are you sure, you want to convert this Quote to BOQ</h5>
                    </div>
                    <div className="txt-center">
                        <button onClick={() => {
                            this.setState({
                                confirmPopup: false
                            });
                        }}
                            className="no_btn"
                        >
                            Cancel
                        </button>
                        {!load ?
                            <button onClick={this.submitHandler} className="okay"> Okay
                            </button>
                            : <button className="okay">Converting...</button>}
                    </div>
                </Modal>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        convertBoqList: state.boq.convertBoqList,
        load: state.boq.load,
        loading: state.boq.loading,
        confirmQuotDropdown: state.boq.confirmQuotDropdown,
        confirmQuotProduct: state.boq.confirmQuotProduct,
        boqData: state.boq.boqData,
        sentBoqProductList: state.boq.sentBoqProductList,
    }
}

export default connect(mapStateToProps)(UnConvertBoq);
